<script src="../router/index.js"></script>
<template>
  <div class="layout" v-loading="loading">
    <Layout style="height: 100vh;">
      <Header>
        <Menu mode="horizontal" theme="dark" active-name="1" @on-select="czs">
          <div class="layout-logo">
            <img src="../../public/images/logo.png" alt="" @click="phindex()">
          </div>
          <div class="layout-nav">
            <MenuItem name="1" style="max-width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">
              <span>公司：{{user.companyName}}</span>
            </MenuItem>
            <MenuItem name="1">
              <Icon type="ios-navigate"></Icon>
              个人
            </MenuItem>
            <MenuItem name="2">
              <Icon type="ios-keypad"></Icon>
              消息
            </MenuItem>
            <MenuItem name="3">
              <Icon type="ios-analytics"></Icon>
              留言
            </MenuItem>
            <MenuItem name="/login" @click="exit()">
              <Icon type="md-exit"/>
              退出登录
            </MenuItem>
          </div>
        </Menu>
      </Header>
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <Menu theme="light" width="auto" @on-select="adthList" accordion>
            <Submenu :name="index" v-for="(item,index) in data" :key="index">
              <template slot="title">
                <Icon :type="item.icon"></Icon>
                {{item.name}}
              </template>
              <MenuItem :name="items.url" v-for="(items,indexs) in item.sonList" v-if="items.type == 0">{{items.name}}</MenuItem>
            </Submenu>
<!--            <Submenu>-->
<!--              <template slot="title">-->
<!--                <Icon type="md-calculator" />-->
<!--                刀具柜管理-->
<!--              </template>-->
<!--              <MenuItem name="/djtype">分类管理</MenuItem>-->
<!--            </Submenu>-->
<!--            <Submenu name="2">-->
<!--              <template slot="title">-->
<!--                <Icon type="md-settings"/>-->
<!--                系统设置-->
<!--              </template>-->
<!--              <MenuItem name="/webSetting">网站设置</MenuItem>-->
<!--              <MenuItem name="/app/version">APP设置</MenuItem>-->
<!--              <MenuItem name="/article/articleList">文章推送</MenuItem>-->
<!--            </Submenu>-->
<!--            <Submenu name="3">-->
<!--              <template slot="title">-->
<!--                <Icon type="ios-contact"/>-->
<!--                用户管理-->
<!--              </template>-->
<!--              <MenuItem name="/user/userList">用户列表</MenuItem>-->
<!--            </Submenu>-->
<!--            <Submenu name="4">-->
<!--              <template slot="title">-->
<!--                <Icon type="ios-home"/>-->
<!--                公司管理-->
<!--              </template>-->
<!--              <MenuItem name="/company/comList">公司列表</MenuItem>-->
<!--              <MenuItem name="/company/auditCom">公司审核</MenuItem>-->
<!--              <MenuItem name="/company/newList">公司公告</MenuItem>-->
<!--              <MenuItem name="/company/auditNew">公告审核</MenuItem>-->
<!--            </Submenu>-->
<!--            <Submenu name="5">-->
<!--              <template slot="title">-->
<!--                <Icon type="ios-build" />-->
<!--                设备管理-->
<!--              </template>-->
<!--              <MenuItem name="/device/list">设备列表</MenuItem>-->
<!--            </Submenu>-->
          </Menu>
        </Sider>
        <Layout :style="{padding: '0 24px 24px'}">
          <div class="mains01" id="yous">
            <Scroll :height="heis" class="hideGd" style="">
              <div style="">
                <div style="width: 100%;height: 10px"></div>
                <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
                  <transition name="fade" mode="out-in">
                    <router-view ></router-view>
                  </transition>
                </Content>
              </div>
            </Scroll>
          </div>
        </Layout>
      </Layout>
    </Layout>
    <style>
      .layout-nav{
        width: 580px !important;
      }
    </style>
  </div>
</template>

<script>
  import {SYNCUSERSTATUS} from "../store/types";
  import httpInd from "@/api/index";

  export default {
    data() {
      return {
        data:[],//菜单数据
        loading:true,
        screenHeight: document.body.clientHeight, // 屏幕高度
        heis:0,
        user:[],
      }
    },
    mounted() {
      var me = this;
      let hei = document.getElementById('yous').scrollHeight+200;
      me.heis = hei;
      // console.log(hei);
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          window.screenHeight = document.body.clientHeight;
          me.screenHeight = window.screenHeight;
        })()
      };
      let user = JSON.parse(sessionStorage.getItem('user'));
      me.user = user;
      // console.log(user);
      let data = {
        roleId: user.roleId,
        mobile: user.mobile,
        sign: user.sign,
        companyId:user.companyId,
        userId:user.userId
      }
      httpInd.getuserpermission(data).then(res => {
        // console.log(res);
        me.data = res.data;
        sessionStorage.setItem('menu',JSON.stringify(res.data));
        me.loading = false;
      })
    },
    methods: {
      adthList(name) {
        this.$router.push(name);
        console.log(name,"????里")
      },
      czs(name) {//退出登录
        var me = this;
        switch (name) {
          case "/login":
            let user =  JSON.parse(sessionStorage.getItem('user'))
            // http.exits(data.id,data.sign).then(res => {
            //   if (res.status == 10005) {//成功
            //     me.$store.dispatch(SYNCUSERSTATUS,null);
            //     sessionStorage.removeItem('user');
            //     me.$message.success(res.message);
            //     setTimeout(function () {
            //       me.$router.push(name)
            //     }, 2000)
            //   } else {
            //     me.$message.error(res.message);
            //     return false;
            //   }
            // })
            sessionStorage.removeItem('user');
            me.$message.success('已退出登录');
            setTimeout(function () {
              me.$router.push(name)
            }, 1500)
            break;
          default:
            me.$message.error('暂未开放');
            return false;
            break;
        }
      },
      phindex(){//返回首页
        var me = this;
        me.$router.push('/index/index');
      }
    }
  };
</script>

<style scoped>
  .layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    height: 100vh;
  }

  .layout-logo {
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
  }

  .layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
  }
  .mains01{
    height: calc(100%) !important;
  }
  .hideGd{
    /*padding-right: 17px;*/
  }
</style>